// src/components/Navbar/Navbar.js
import React, { useEffect } from 'react';
import './Navbar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Collapse } from 'bootstrap';

const Navbar = () => {

  useEffect(() => {
    const navLinks = document.querySelectorAll('.nav-link');
    const navbarCollapse = document.getElementById('navbarContent');

    if (!navbarCollapse) return;

    const bsCollapse = new Collapse(navbarCollapse, {
      toggle: false
    });

    const handleNavLinkClick = () => {
      if (window.innerWidth <= 768 && navbarCollapse.classList.contains('show')) {
        bsCollapse.hide();
      }
    };

    navLinks.forEach(link => {
      link.addEventListener('click', handleNavLinkClick);
    });

    // Cleanup on unmount
    return () => {
      navLinks.forEach(link => {
        link.removeEventListener('click', handleNavLinkClick);
      });
    };
  }, []);

  return (
    <header className="navbar-wrapper shadow-sm">
      <div className="top-bar bgtop text-white small mobilehide">
        <div className="container d-flex justify-content-between align-items-center flex-wrap py-3">
          <div className="d-flex align-items-center flex-wrap">
            <a href="tel:+919816791456" className="text-white text-decoration-none me-3">
              <i className="bi bi-telephone-fill me-1"></i> +91 9816791456
            </a>
            <a href="mailto:nashamuktikendrasolanhp@gmail.com" className="text-white text-decoration-none me-3">
              <i className="bi bi-envelope-fill me-1"></i> nashamuktikendrasolanhp@gmail.com
            </a>
            <span className="d-flex align-items-center mt-2 mt-md-0">
              <i className="bi bi-geo-alt-fill me-1"></i> VILL SIRINAGR TEH, KANDAGHAT 1214, KANDAGHAT 173215
            </span>
          </div>
          <div className="social-icons d-flex align-items-center mt-3 mt-md-0">
            <a href="/" className="text-white me-3"><i className="bi bi-facebook"></i></a>
            <a href="/" className="text-white me-3"><i className="bi bi-instagram"></i></a>
            <a href="/" className="text-white"><i className="bi bi-google"></i></a>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg navbar-dark text-light main-navbar">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src="/assets/logo.jpg" alt="AuraCare" />
            <span className="ms-2 brand-text">Nasha Mukti Kendra Solan</span>
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent"
            aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation"
            style={{ backgroundColor: "green" }}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse custom-mobile-nav" id="navbarContent">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a href="/" className="nav-link">Home</a></li>
              <li className="nav-item"><a href="#about" className="nav-link">About Us</a></li>
              <li className="nav-item"><a href="#services" className="nav-link">Service</a></li>
              <li className="nav-item"><a href="#gallery" className="nav-link">Gallery</a></li>
              <li className="nav-item"><a href="#contact" className="nav-link">Contact Us</a></li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
